var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{attrs:{"type":"light"}},[_c('b-navbar-brand',{staticClass:"text-basic-black",attrs:{"href":"/"}},[_c('span',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo_small.png")}})]),_vm._v("\n    admin\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b0e4301","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/Header.vue
// module id = null
// module chunks = 